import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_patient_summary = _resolveComponent("patient-summary")!
  const _component_doctor_workflow = _resolveComponent("doctor-workflow")!
  const _component_nurse_workflow = _resolveComponent("nurse-workflow")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "4" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              elevation: 4,
              class: "rounded-shaped",
              color: "blue-grey-lighten-1"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-account")
                      ]),
                      _: 1
                    }),
                    _createTextVNode(" Patient Detail ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "8 text-right" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_tooltip, {
              text: "Dispatch",
              location: "top"
            }, {
              activator: _withCtx(({ props }) => [
                _createVNode(_component_v_btn, _mergeProps({ class: "mr-2" }, props, {
                  color: "primary",
                  "prepend-icon": "mdi-home"
                }), {
                  default: _withCtx(() => [
                    _createTextVNode(" Dispatch ")
                  ]),
                  _: 2
                }, 1040)
              ]),
              _: 1
            }),
            _createVNode(_component_v_tooltip, {
              text: "Back to Home",
              location: "top"
            }, {
              activator: _withCtx(({ props }) => [
                _createVNode(_component_v_btn, _mergeProps({ class: "mr-2" }, props, {
                  to: "/",
                  "prepend-icon": "mdi-home"
                }), {
                  default: _withCtx(() => [
                    _createTextVNode(" Home ")
                  ]),
                  _: 2
                }, 1040)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _createVNode(_component_patient_summary, { patient: _ctx.patientSummary }, null, 8, ["patient"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            (_ctx.store.role !=='nurse')
              ? (_openBlock(), _createBlock(_component_doctor_workflow, {
                  key: 0,
                  patient: _ctx.patientSummary
                }, null, 8, ["patient"]))
              : _createCommentVNode("", true),
            (_ctx.store.role ==='nurse')
              ? (_openBlock(), _createBlock(_component_nurse_workflow, {
                  key: 1,
                  patient: _ctx.patientSummary
                }, null, 8, ["patient"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}